import { useSyncExternalStore, type AnchorHTMLAttributes, type MouseEvent } from "react";

const EVENTO = "navegacao";

/**
 * Navegacao minima sobre a History API: caminho atual, `navegar` e `Link`.
 *
 * Sem biblioteca de rotas de proposito: a aplicacao tem poucas telas e nenhuma
 * rota com parametro. Quando passar a ter (ex.: `/pacientes/:id`), troque por
 * uma biblioteca de rotas mantendo estas tres funcoes como fronteira.
 */
export function navegar(caminho: string, opcoes: { substituir?: boolean } = {}): void {
  if (opcoes.substituir) window.history.replaceState(null, "", caminho);
  else window.history.pushState(null, "", caminho);
  window.dispatchEvent(new Event(EVENTO));
}

function assinar(aoMudar: () => void): () => void {
  window.addEventListener("popstate", aoMudar);
  window.addEventListener(EVENTO, aoMudar);
  return () => {
    window.removeEventListener("popstate", aoMudar);
    window.removeEventListener(EVENTO, aoMudar);
  };
}

/** Caminho atual (sem query). Re-renderiza quando muda. */
export function usarCaminho(): string {
  return useSyncExternalStore(assinar, () => window.location.pathname);
}

/** Parametro da query string atual. */
export function parametroDaUrl(nome: string): string | null {
  return new URLSearchParams(window.location.search).get(nome);
}

/** Parametro da query que re-renderiza quando a URL muda, inclusive no mesmo caminho. */
export function usarParametro(nome: string): string | null {
  return useSyncExternalStore(assinar, () => new URLSearchParams(window.location.search).get(nome));
}

/**
 * Link que navega sem recarregar a pagina. Clique com Ctrl/Cmd ou botao do meio
 * continua abrindo em nova aba, como o usuario espera de um link.
 */
export function Link({
  para,
  onClick,
  ...resto
}: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & { readonly para: string }) {
  function aoClicar(evento: MouseEvent<HTMLAnchorElement>) {
    onClick?.(evento);
    if (
      evento.defaultPrevented ||
      evento.button !== 0 ||
      evento.metaKey ||
      evento.ctrlKey ||
      evento.shiftKey ||
      evento.altKey
    ) {
      return;
    }
    evento.preventDefault();
    navegar(para);
  }
  return <a href={para} onClick={aoClicar} {...resto} />;
}
